import React from 'react'
import { BulkUpdateTableCellActionsWrapper } from './BulkUpdateTableCellActionsWrapper'

interface BulkUpdateTableEditableCellRendererProps {
  value: any // any value can be passed in here because we don't know the type of the value gonna be passed in
  isLastColumn: boolean
  totalRows: number
  rowIndex: number
  onDeleteRow: (index: number) => void
}

export const BulkUpdateTableEditableCellRenderer: React.FC<
  BulkUpdateTableEditableCellRendererProps
> = ({ value, isLastColumn, totalRows, rowIndex, onDeleteRow }) => {
  return (
    <BulkUpdateTableCellActionsWrapper
      isLastColumn={isLastColumn}
      totalRows={totalRows}
      rowIndex={rowIndex}
      onDeleteRow={onDeleteRow}
      showEditIcon
      padding="0 4px"
    >
      <span>{value}</span>
    </BulkUpdateTableCellActionsWrapper>
  )
}
